export default __webpack_public_path__ + "static/media/edit.ca7ec7cb.svg";